import { UserRoundPlusIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { Tooltip } from '@air/primitive-tooltip';

export type LibraryAdvancedSettingsAssignOwnersProps = {
  onAssignOwners?: () => void;
};

export const LibraryAdvancedSettingsAssignOwners = ({ onAssignOwners }: LibraryAdvancedSettingsAssignOwnersProps) => {
  return (
    <div>
      <h3 className="mb-2 font-bold ads:text-secondary text-10 text-pigeon-500 uppercase tracking-wide">
        Leave library
      </h3>
      <p className="mb-4 ads:text-secondary text-12 text-pigeon-500">
        Remove library from sidebar and my access to its contents
      </p>
      {onAssignOwners && (
        <Tooltip label="Assign another owner to leave library" side="right">
          <Button appearance="outline" color="gray" onClick={onAssignOwners} prefix={<UserRoundPlusIcon size="sm" />}>
            Assign owners
          </Button>
        </Tooltip>
      )}
    </div>
  );
};
